import React from 'react';

function appendScript(baseUrl, setScriptLoaded, setLoadError) {
    if (window.MktoForms2) return setScriptLoaded(true);

    const onLoad = () => (window.MktoForms2 ? setScriptLoaded(true) : null);
    const onError = () => setLoadError(true);

    const script = document.createElement('script');
    script.src = `${baseUrl}/js/forms2/js/forms2.min.js`;
    script.async = true;
    script.addEventListener('load', onLoad);
    script.addEventListener('error', onError);
    document.body.appendChild(script);
}

export default function useMarketo({ baseUrl, munchkinId, formId, callback }) {
    const [scriptLoaded, setScriptLoaded] = React.useState(false);
    const [loadError, setLoadError] = React.useState(false);

    React.useEffect(() => {
        if (scriptLoaded) {
            window.MktoForms2.loadForm(baseUrl, munchkinId, formId, callback);
            return;
        }

        appendScript(baseUrl, setScriptLoaded, setLoadError);
    }, [scriptLoaded, baseUrl, munchkinId, formId, callback]);

    return [scriptLoaded, loadError];
}
